import { Table, Avatar, Typography } from "antd";
import { useNavigate } from "@shared/lib/react-router";
import "./project-history.scss";

const historyData = [
  {
    key: "1",
    employee: "Дима Харин",
    position: "Дизайнер",
    organization: 'ООО "Организация"',
    event: "Назначение администратора",
    date: "02.08.2024",
    time: "16:13 МСК",
  },
  {
    key: "2",
    employee: "Дима Харин",
    position: "Дизайнер",
    organization: 'ООО "Интэнт"',
    event: "Создание проекта",
    date: "02.08.2024",
    time: "16:13 МСК",
  },
];

export const ProjectHistory = () => {
  const navigate = useNavigate();

  const handleEmployeeClick = (employeeName: string) => {
    navigate(`/employee/${employeeName}`);
  };

  const columns = [
    {
      title: <span className="project-history__header-label">Сотрудник</span>,
      dataIndex: "employee",
      key: "employee",
      render: (text: string) => (
        <div className="project-history__employee-row">
          <Avatar
            src="https://via.placeholder.com/40"
            alt="avatar"
            className="project-history__avatar"
          />
          <span
            onClick={() => handleEmployeeClick(text)}
            className="project-history__employee-link"
          >
            {text}
          </span>
        </div>
      ),
    },
    {
      title: <span className="project-history__header-label">Должность</span>,
      dataIndex: "position",
      key: "position",
    },
    {
      title: <span className="project-history__header-label">Организация</span>,
      dataIndex: "organization",
      key: "organization",
    },
    {
      title: <span className="project-history__header-label">Событие</span>,
      dataIndex: "event",
      key: "event",
    },
    {
      title: <span className="project-history__header-label">Дата, Время</span>,
      dataIndex: "date",
      key: "date",
      render: (text: string, record: { time: string }) => (
        <div className="project-history__datetime">
          <span className="project-history__date">{text}</span>
          <span className="project-history__time">{record.time}</span>
        </div>
      ),
    },
  ];

  return (
    <div className="project-history">
      <Typography.Title level={4} className="project-history__title">
        История проекта
      </Typography.Title>
      <Table
        columns={columns}
        dataSource={historyData}
        pagination={false}
        bordered={false}
        className="history-table"
      />
    </div>
  );
};
